import styled from 'styled-components';
export const DivErrorMessage = styled.div`
  position: relative;
  bottom: 15px;
  font-size: 12px;
  line-height: 12px;
  color: rgb(244, 67, 54);
  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
  padding-top: 8px;
  margin-top: 16px;
  border-top: 1px solid;
`



// WEBPACK FOOTER //
// ./src/pages/styled.js